import { Component, Input, OnInit } from '@angular/core';
import { ImageScaleFactorModel } from '../../model/images/image-scale-factor-model';

@Component({
  selector: 'act-image',
  templateUrl: './act-image.component.html',
  styleUrls: ['./act-image.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class ActImageComponent implements OnInit {

  @Input()
  image: ImageScaleFactorModel;

  @Input() contentClass: string;

  defaultImage = '';
  scaleFactorImage = '';

  constructor() { }

  ngOnInit() {
    // console.log('on init act image ', this.image);
    this.defaultImage = this.image['2x'];
    this.scaleFactorImage = `${this.image['1x']} 1x, ${this.image['2x']} 2x, ${this.image['3x']} 3x`;
  }

  ngAfterViewInit() {
    // console.log('on init act image ', this.image);
  }

  onImgError(event) {
    this.scaleFactorImage = undefined;
    event.target.src = 'https://images.ascendtravel.com/NoImage.jpg';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/act-image/act-image.component.ts